export default "__VITE_ASSET__7ECaGrMa__"